<template>
   <div class="actions-button-wrapper-999">
       <slot name="videomarkinmarkout"></slot>
   </div>
</template>

<script>
export default {
   name:'PlayerAndMarkinMarkoutWrapperComponent',
   data(){
       return {
           playerObj:{}
       }
   },

   mounted(){
     this.$root.$on('player-obj', player => {
         this.playerObj = player
     });
   }
}
</script>

<style>

</style>